module.exports = __webpack_public_path__ + "img/bank-index-nav-top-img.c3c71826.png";